// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__sVW0F","main":"Dashboard_main__c0Oja"};